var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label":_vm.field.label,"label-for":("id_" + (_vm.field._id))}},[_c('b-form-textarea',{directives:[{name:"validate",rawName:"v-validate",value:({
                required: _vm.field.isRequired,
            }),expression:"{\n                required: field.isRequired,\n            }"}],class:{
                'is-invalid': _vm.errors.has(_vm.field.label),
                'is-invalid': _vm.isInvalid,
            },attrs:{"id":"textarea","placeholder":_vm.field.placeholder,"rows":"3","max-rows":"3","disabled":_vm.loading || _vm.isDisable,"data-vv-name":_vm.field.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }